import React, {useState} from "react";
import {Box, Button, Column, Columns, Input, Table, Title} from "@allxsmith/bestax-bulma";
import NewOptionRow from "./NewOptionRow"


export default function NewCategory({onSave}){
    const [category, setCategory] = useState({
        options: [],
        name: "",
        status: "Active"
    });

    const onChange = e => {
        let newCategory = {...category, [e.target.name]: e.target.value}
        setCategory(newCategory);
    }
    const newOption = () => {
        let newOption = {
            name: "",
            status: "ACTIVE"
        }
        let options = [...category.options];
        options.push(newOption);
        const toUpdate = {
            target: {
                name: "options",
                value: options
            }
        };
        onChange(toUpdate);
    }
    const onOptionChange = (e, index) => {
        let newOption = {...category.options[index], [e.target.name]: e.target.value}
        let newOptions = [...category.options]
        newOptions[index] = newOption
        const toUpdate = {
            target: {
                name: "options",
                value: newOptions
            }
        };
        onChange(toUpdate);
    }


    return (
        <Box>
            <details>
                <summary><Title>Add Tracking Category</Title></summary>
            <Columns isMultiline>
                <Column>
                    <label className="label">Category Name</label>
                    <Input
                        type={"text"}
                        name={"name"}
                        value={category.name}
                        onChange={onChange}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table>
                        <thead>
                            <tr>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {category.options.map((option, index) => (
                                <NewOptionRow
                                    option={option}
                                    index={index}
                                    onChange={onOptionChange}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"info"}
                        onClick={newOption}
                    >
                        New Option
                    </Button>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onSave(category)}
                        isFullWidth
                    >
                        Save
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );




}